import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../../../utils/style';
import { identity } from '../../../../../utils/sizes';
import { SIZE as ARROW_SIZE } from '../../../../../navigation-arrow/navigationArrow.style';

export const defaultContext = makeDefaultStylingContext();

const colors = {
  backdrop: makeThemeColor(TERTIARY, 0.5),
  background: makeThemeColor(TERTIARY),
  text: makeThemeColor(PRIMARY),
};

export const GAP = 8;

export const getInitialStyle = ({ colorMode, screenSize } = defaultContext) => {
  const font = getFont(FONT.KINSHASA_2, screenSize);

  return {
    ArrowLeft: {},
    ArrowRight: {
      x: identity,
      mountX: 1,
    },
    Title: {
      color: colors.text[colorMode],
      x: ARROW_SIZE[screenSize] + GAP,
      y: Math.round((ARROW_SIZE[screenSize] - font.lineHeight) / 2),
      w: v => v - ARROW_SIZE[screenSize] * 2 - GAP * 2,
      text: {
        ...font,
        textAlign: 'center',
        verticalAlign: 'middle',
        wordWrap: false,
        textOverflow: '...',
      },
    },
  };
};
